import { useMemo } from "react";
// import { HighlightOff } from "@mui/icons-material";

import NewTabs from "../new-client-dashboard/NewTabs";

// Pure presenter. Parent owns activeTab and the list of opened firm tabs.
const CoPilotTabs = ({ activeTab, firmTabs = [], onSelect }) => {
  const mainTabs = useMemo(() => {
    const baseTab = {
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      leftHand: true,
    };

    return [
      {
        ...baseTab,
        id: "directory",
        label: "Directory",
        onClick: () => onSelect?.("directory"),
      },
      ...firmTabs.map((firm) => ({
        ...baseTab,
        id: `firm-${firm.firm_id}`,
        label: firm.firm_name,
        onClick: () => onSelect?.(`firm-${firm.firm_id}`),
        // rightHand: true,
        // leftHand: false,
        // span: (
        //   <>
        //     <span
        //       className="fw-bold m-l-5 ic-15 d-flex align-items-center justify-content-center p-r-5"
        //       style={{
        //         width: "15px",
        //         height: "15px",
        //       }}
        //       onClick={(e) => {
        //         e.stopPropagation();
        //         onSelect?.("directory");
        //       }}
        //     >
        //       <HighlightOff size={16} />
        //     </span>
        //   </>
        // ),
      })),
    ];
  }, [firmTabs, onSelect]);

  return (
    <NewTabs
      currentTab={activeTab}
      tabsData={mainTabs}
      height={25}
      labelClass="justify-content-start"
      widthTab={true}
      popupTabs={true}
      mainContainerClass=""
      containerClass="ps-0 pe-2"
    />
  );
};

export default CoPilotTabs;
